import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import VueRouter from 'vue-router';

import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';

Vue.use(ElementUI);

Vue.config.productionTip = false

//el-form @submit.native.prevent;阻止自动提交表单


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
